import { en } from './en';

export const messagesAll: { [key: string]: { [key: string]: string } } = {
  en,
};
